import { ErrorLogComponent } from '@cian/error-log-component';
import { useDeviceType } from '@cian/ui-kit';
import loadable from '@loadable/component';
import Cookies from 'js-cookie';
import * as React from 'react';

import { useIsOnboardingDisplayAllowed } from './useIsOnboardingDisplayAllowed';
import { useIsOnboardingEnabled } from './useIsOnboardingEnabled';
import { useOnboardingFirstVisitTimestamp } from './useOnboardingFirstVisitTimestamp';
import { ONBOARDING_FIRST_VISIT_COOKIE_NAME } from '../../constants/cookies';
import { useApplicationContext } from '../../utils/applicationContext';

const OnboardingContainerLoadable = loadable(() => import('./OnboardingContainerLoadable'), {
  resolveComponent: module => module.OnboardingContainer,
});

export function OnboardingContainer() {
  const ctx = useApplicationContext();
  const isEnabled = useIsOnboardingEnabled();
  const isMobile = useDeviceType() === 'phone';

  const { firstVisitTimestamp, shouldPersistFirstVisitTimestamp } = useOnboardingFirstVisitTimestamp(isMobile);
  const isDisplayAllowed = useIsOnboardingDisplayAllowed(isMobile, firstVisitTimestamp);
  const shouldShow = isEnabled && isDisplayAllowed;
  const [wasLoadableMounted, setWasLoadableMounted] = React.useState(false);

  React.useEffect(() => {
    if (!shouldPersistFirstVisitTimestamp || firstVisitTimestamp === undefined) {
      return;
    }
    Cookies.set(ONBOARDING_FIRST_VISIT_COOKIE_NAME, String(firstVisitTimestamp), {
      domain: '.cian.ru',
      expires: 365,
    });
  }, [firstVisitTimestamp, shouldPersistFirstVisitTimestamp]);

  React.useEffect(() => {
    if (shouldShow) {
      setWasLoadableMounted(true);
    }
  }, [shouldShow]);

  if (!isEnabled || (!isDisplayAllowed && !wasLoadableMounted)) {
    return null;
  }

  return (
    <ErrorLogComponent logger={ctx.logger}>
      <OnboardingContainerLoadable shouldShow={shouldShow} />
    </ErrorLogComponent>
  );
}
